export const Step = {
  Name: 'name',
  Team: 'team',
  Success: 'success',
} as const;

export type StepType = (typeof Step)[keyof typeof Step];
